// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__19o7a","containerItemsCenter":"Skeleton_containerItemsCenter__e4gWF"};